module.exports = __webpack_public_path__ + "static/media/pexels-pixabay-371936.6fd9ff09.jpg";